module.exports = __webpack_public_path__ + "static/media/success-tick-green.1b778e39.svg";